import React, { useState } from "react";
import "./bottom-modal-styles.css";
import MainButton from "../main-button/main-button";

const BottomModal = ({ onClose, children, title }) => {
  const [closeModalClass, setCloseModalClass] = useState(null);
  const _closeHandler = () => {
    setCloseModalClass("closeModalClass");
    setTimeout(() => {
      onClose();
    }, 400);
  };
  return (
    <div className={`bottomModalWrapper ${closeModalClass}`}>
      <div className="bottomModalHeader">
        <p>{title}</p>
      </div>
      <div>{children}</div>
      <div className="bottomModalButtonsWrapper">
        <MainButton
          onClick={_closeHandler}
          styles={{
            backgroundColor: "#007fFF",
            color: "#fff",
          }}
        >
          Close
        </MainButton>
      </div>
    </div>
  );
};

export default BottomModal;
